import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

declare global {
    interface Window {
        _mtm?: Array<Record<string, unknown>>;
    }
}

export const App: React.FC = () => {
    useEffect(() => {
        const _mtm = (window._mtm = window._mtm || []);
        _mtm.push({ 'mtm.startTime': Date.now(), event: 'mtm.Start' });

        const d = document;
        const g = d.createElement('script');
        const s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = 'https://ifbbama.org/stats/js/container_UXgv7dcR.js';
        s.parentNode?.insertBefore(g, s);
    }, []);

    return <Outlet />;
};

